import React, { useCallback } from 'react';
import { FontIcon } from 'react-md';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

import featureFlags from 'lib/featureFlags';
import { useOldestDocumentDateFromFeeds } from 'lib/hooks';
import ButtonWithDropdown from 'components/common/ButtonWithDropdown';
import ReportConfirmationDialog from 'components/Report/ConfirmationDialog/ReportConfirmationDialog';
import { ReactComponent as XlsIcon } from 'vendor/svg/report/xls-icon.svg';

import DashboardDropDown from './Export/DashboardDropDown';

export function ExportDropDownMenu(
	{
		total,
		user,
		showExport,
		quickReportEnabled,
		reportConfirmationDialogEnbaled = false,
		reportedFocusNames,
		filters,
		handleQuickReport,
		setReportConfirmationDialogEnabled,
		onSetReportedFocusNames
	}: {
		total: number,
		user: any,
		showExport: boolean,
		quickReportEnabled: boolean,
		reportConfirmationDialogEnbaled?: boolean
		setReportConfirmationDialogEnabled: (enabled: boolean) => void
		handleQuickReport: () => void,
		reportedFocusNames: string[],
		filters: any
		onSetReportedFocusNames: (names: string[]) => void
	}) {

	const feeds = (!isEmpty(filters) && !isEmpty(filters.feeds)) ? filters.feeds.values : [];
	const oldestDocumentDateHook = useOldestDocumentDateFromFeeds(feeds);
	const { t } = useTranslation();

	const textKeys = total !== 0 && reportedFocusNames.length > 0 ? {
		title: 'reports.confirmation_message_1',
		content: 'reports.confirmation_message_2_article',
		footer: 'reports.confirmation_message_3'
	} : {
		title: 'reports.confirmation_reject_message_1',
		content: 'reports.confirmation_reject_message_2',
		footer: ''
	};

	const oldestDocumentDate = featureFlags.isEnabled('excel-report-builder') ? oldestDocumentDateHook : '';

	const getDropdownItems = useCallback(() => {
		return [
			{
				hide: !featureFlags.isEnabled('excel-report-builder'),
				component: <DashboardDropDown
					filters={filters}
					availableDataDate={oldestDocumentDate}
					entrypoint='report'
					item={{
						icon: <XlsIcon style={{ opacity: '0.54' }} />,
						id: 'excel-report-builder-button',
						disabled: !quickReportEnabled,
						label: t('export_dropdown_menu.analyze_and_share.excel_report_builder')
					}} />
			},
			{
				hide: !featureFlags.isEnabled('new-dashboard'),
				component: <DashboardDropDown
					filters={filters}
					beta={true}
					item={{
						id: 'analyse-and-share-dashboard',
						disabled: !quickReportEnabled,
						label: t('export_dropdown_menu.analyze_and_share.dashboard'),
						icon: <FontIcon >insert_chart_outlined</FontIcon>
					}} />
			},
			{
				id: 'analyse-and-search-export-excel',
				label: t('export_dropdown_menu.analyze_and_share.export_to_excel'),
				onClick: handleQuickReport,
				disabled: !quickReportEnabled,
				icon: <FontIcon >save_alt</FontIcon>
			}
		];
	}, [filters, handleQuickReport, quickReportEnabled, oldestDocumentDate, t]);

	return (
		<>

			<ReportConfirmationDialog
				enabled={reportConfirmationDialogEnbaled}
				onCancel={() => {
					setReportConfirmationDialogEnabled(false);
					onSetReportedFocusNames([]);
				}}
				textKeys={textKeys}
				focuses={reportedFocusNames}
				type='excel'
				user={user}
			/>
			{
				showExport && (
					<div>
						<ButtonWithDropdown
							text={t('export_dropdown_menu.analyze_and_share.label')}
							id='analyze-and-share'
							items={getDropdownItems()}
						/>
					</div>
				)}
		</>
	);

}
